import {Alert} from "@/components/alert/Alert.tsx";

export const PSErrorState = ({error}: {error: string}) => (
  <div className="p-5 text-center">
    <Alert variant={"error"}>Error: {error}</Alert>
  </div>
);
